/**
 * The registry contract: src/worlds/registry.ts globs `world.meta.ts` and reads the
 * NAMED export `meta`. `slug` must equal this directory's name or the registry reports
 * the world as unregistered rather than dropping it silently.
 */
export const meta = {
  id: "FW-20",
  name: "Brine & Bloom",
  slug: "brine-and-bloom",
  title: "Brine & Bloom — a Fable World: food storefront",
  description:
    "An original food storefront designed by Fable: a fermentation ledger whose numbers reconcile on one shared beat."
} as const;

export type BrineMeta = typeof meta;
export default meta;
